<template>
    <div class="card card-height">
        <div class="table-responsive">
            <table class="table custom-table-padding">
                <thead>				
                    <tr>
                        <th>OT No</th>
                        <th>Date & Time</th>
                        <th>Name of Operation</th>
                        <th>Service Name</th>
                        <th>Surgeons</th>
                        <th class="action-th">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in tableItems" :key="i">

                        <td> 
                            <div class="col">
                                {{ item.id }}
                            </div>
                        </td>

                        <td>
                            {{ item.operation_date }}
                        </td>

                        <td>
                          {{ item.name_of_operation }}
                        </td>

                        <td>
                            {{ item.product ? item.product.name : '' }}
                        </td>

                        <td>
                            {{ getDoctorsName(item.ot_order_service) }}
                        </td>

                        <td>
                            <div class="action">
                                <button @click="editOTOrder(item)" class="btn btn-primary btn-sm print-btn">
                                    <i class="fas fa-pen"></i>
                                </button>
                              <button :disabled="loading" @click="deleteOTOrder(item)" class="btn btn-outline-danger btn-sm print-btn">
                                <i class="fas fa-trash"></i>
                              </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
</div>
</template>

<script setup>
    import { useRoute, useRouter } from "vue-router";
    import handleHospital from '@/services/modules/hospital'
    import { ref, inject } from "vue";

    const { removeOtOrder } = handleHospital();

    const $route = useRoute();
    const $router = useRouter();
    const showError = inject('showError');
    const showSuccess = inject('showSuccess');

    const props = defineProps({
        tableItems: {
            type: Array,
        },
        onEditOTOrder: Function,
        onDelete: {
          type: Function,
          default: () => {}
        }
    })
    const loading = ref(false);

    const emit = defineEmits(['onEditOTOrder','onDelete']);

    const editOTOrder = (item) => {
        emit('onEditOTOrder', item)
    }

    const getDoctorsName = (services) => {
        if(!services) return '';

        const doctors = services.filter(item => item.pivot.type === 'surgeon')
                                .map(item => item.name);
                                
        return doctors.join(", ");
    }

    const deleteOTOrder = async (item) => {

      if(!confirm('Are you sure you want to delete this Ot Order?')) return;

      const query = '?company_id=' + $route.params.companyId;

      loading.value = true

      try {
        let res = await removeOtOrder(query, item.id);
        if (!res.status) {
          showError(res.message);
          return;
        }
        emit('onDelete');
        showSuccess(res.message)
      } catch (err) {
        console.log(err,"err")
        if (!err.response) {
          showError('Something is wrong. Check your connectivity!!');
          return;
        }
        showError(err.response.message)
      } finally {
        loading.value = false
      }
    }
</script>

<style scoped>

.admission-no{
    width: 15%;
}
.patient-details{
    width: 25%;
}
.print-btn{
    margin-right: 5px;
}
.action-th{
    width: 15%;
    text-align: center;
}
.action{
    text-align: center;
}

.profile-pic{
    width: 65px;
}
</style>